module.exports = {"520181100":"红枫湖镇","520181101":"站街镇","520181102":"卫城镇","520181103":"新店镇","520181104":"暗流镇","520181105":"犁倭镇","520181201":"麦格苗族布依族乡","520181203":"王庄布依族苗族乡","520181204":"流长苗族乡","520181400":"新岭社区服务中心","520181401":"红塔社区服务中心","520181402":"巢凤社区服务中心","520181403":"百花社区服务中心","520181405":"红新社区服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520181.json
// module id = 2270
// module chunks = 0